/** Site ordering + default selection for the single-site dashboard (POS2-913). */

/** Sites sorted case-insensitively by name (a new array; input is not mutated). */
export function sortSitesByName<T extends { name: string }>(sites: readonly T[]): T[] {
  return [...sites].sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
}

/** The dashboard's default site: the first alphabetically, or null when the user
 * has no sites. */
export function pickDefaultSiteId(sites: readonly { id: string; name: string }[]): string | null {
  return sortSitesByName(sites)[0]?.id ?? null;
}
